import React, { useEffect, useState } from "react";
import API from "../Services/Auth";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx";
import CenterModal from "../Components/CenterSelectorModal";
const CustomerList = () => {
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const pastDate = new Date();
  pastDate.setDate(pastDate.getDate() - 90);
  const formattedPastDate = pastDate.toISOString().split("T")[0];

  const [currentPage, setCurrentPage] = useState(1);
  const [customer, setCustomer] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const perPage = 10;
  const [selectedCenter, setSelectedCenter] = useState([]);
  const [search, setSearch] = useState({
    searchText: "",
    from_date: "",
    to_date: ""
  });

  useEffect(() => {
    if (selectedCenter.length > 0) {
      bindCustomerData(currentPage);
    }
  }, [currentPage, selectedCenter]);

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    setSearch((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleSearch = () => {
    setCurrentPage(1);
    bindCustomerData(1);
  };

  const bindCustomerData = async (currentPage) => {
    try {
      const centerlist = Array.isArray(selectedCenter)
        ? selectedCenter.join(",")
        : selectedCenter;
      const payload = {
        limit: perPage,
        pageNumber: currentPage,
        search: search.searchText,
        from_date: search.from_date || formattedPastDate,
        to_date: search.to_date || formattedToday,
        location_id: centerlist || null
      };
      const response = await API.getCustomerData(payload);
      setCustomer(response?.data?.customers || []);
      const totalPages = Math.ceil(response?.data?.total_count / perPage);
      setTotalCount(response?.data?.total_count);
      setTotalPages(totalPages);
    } catch (error) {
      handleError(error);
      if (!error.response) {
        toast.error("Network error! Please check your internet connection");
      } else if (error.response.status === 403) {
        window.location.replace("/Login");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  const handleError = (error) => {
    // console.error("Error:", error);
    if (error.response) {
      toast.error(error.response.data?.message || `Error: ${error.response.status}`);
    } else if (error.request) {
      toast.error("No response from server. Please try again later.");
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const getPageNumbers = () => {
    const maxVisible = 10;
    const pageNumbers = [];
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const left = Math.max(1, currentPage - 3);
      const right = Math.min(totalPages, currentPage + 3);

      if (left > 2) {
        pageNumbers.push(1, "...");
      } else {
        for (let i = 1; i < left; i++) {
          pageNumbers.push(i);
        }
      }
      for (let i = left; i <= right; i++) {
        pageNumbers.push(i);
      }
      if (right < totalPages - 1) {
        pageNumbers.push("...", totalPages);
      } else {
        for (let i = right + 1; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      }
    }
    return pageNumbers;
  };

  const downloadCSV = async () => {
    try {
      const centerlist = Array.isArray(selectedCenter)
        ? selectedCenter.join(",")
        : selectedCenter;

      const payload = {
        limit: 0,
        pageNumber: currentPage,
        search: search.searchText,
        from_date: search.from_date || formattedPastDate,
        to_date: search.to_date || formattedToday,
        location_id: centerlist || null
      };

      const data = await API.getCustomerData(payload);
      const result = data?.data?.customers || [];
      if (!result.length) {
        toast.error("No data found!");
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(result);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "CustomerRecord");
      XLSX.writeFile(workbook, "CustomerRecord.xlsx");
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };
  const handleSelectedCenter = (selectedData) => {
    setSelectedCenter(selectedData);
  };


  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Total Customer ({totalCount})</h4>
            {totalCount > 0 && (
              <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                <i className="fa fa-download"></i>
              </button>
            )}
          </div>

          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-3">
                <CenterModal onSelectCenter={handleSelectedCenter} />
              </div>
              <div className="col-md-3">
                <label>Name, Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Name, Mobile"
                  value={search.searchText}
                  onChange={(e) => handleFieldChange(e, "searchText")}
                />
              </div>

              <div className="col-md-3">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={search.from_date || ""}
                  // min={formattedPastDate}
                  max={formattedToday}
                  onChange={(e) => handleFieldChange(e, "from_date")}
                />
              </div>

              <div className="col-md-3">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={search.to_date || ""}
                  min={search.from_date}
                  max={
                    search.from_date
                      ? moment(search.from_date).add(90, "days").isAfter(moment())
                        ? moment().format("YYYY-MM-DD")
                        : moment(search.from_date).add(90, "days").format("YYYY-MM-DD")
                      : formattedToday
                  }
                  onChange={(e) => handleFieldChange(e, "to_date")}
                />
              
              </div>

              <div className="col-md-3 d-flex align-items-end">
                <button
                  onClick={handleSearch}
                  className="btn btn-success w-100"
                  type="button"
                >
                  Search
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Customer Name</th>
                    <th>Phone</th>
                    <th>DOB</th>
                    <th>Center Name</th>
                    <th>Membership</th>
                    <th>Gender</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {customer.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                      <td>{item?.name}</td>
                      <td>{item?.mobile}</td>
                      <td>{item?.date_of_birth}</td>
                      <td>{item?.center_name}</td>
                      <td>{item?.membership_plan}</td>
                      <td>{item?.gender}</td>
                      <td>{item?.state_name}</td>
                      <td>{item?.city_name}</td>
                      <td>{moment(item.createdAT).format("DD-MM-YYYY")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center mt-4">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                  </li>

                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${page === currentPage ? "active" : ""
                        } ${page === "..." ? "disabled" : ""}`}
                    >
                      {page === "..." ? (
                        <span className="page-link">...</span>
                      ) : (
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      )}
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default CustomerList;
